module.exports = __webpack_public_path__ + "img/HZ-A1252.fe01b62c.jpg";